// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:992px){.imported-activity-stats[data-v-57548385]{display:none}.imported-activity-stats--horizontal[data-v-57548385]{display:block}}@media screen and (max-width:991px){.imported-activity-stats[data-v-57548385]{display:block}.imported-activity-stats--horizontal[data-v-57548385]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
